//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'HowVideoSlide',
  props: {
    videoUrl: {
      type: String,
      required: true,
      default: '',
    },
    isActive: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      isPaused: true,
    }
  },
  methods: {
    startVideo() {
      this.isPaused = false
      this.$refs.video.play()
    },
    pauseVideo() {
      this.isPaused = true
      this.$refs.video.pause()
    },
    handleClick() {
      if (this.isActive) {
        this.isPaused = false
        this.$refs.video.play()
      }
    },
  },
}
